var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowdownwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.120532 0.37295C0.266632 0.22392 0.495254 0.210372 0.656358 0.332305L0.702513 0.37295L4 3.73671L7.29749 0.37295C7.44359 0.22392 7.67221 0.210372 7.83331 0.332305L7.87947 0.37295C8.02557 0.521979 8.03885 0.755187 7.91931 0.919521L7.87947 0.966603L4.29099 4.62705C4.14489 4.77608 3.91627 4.78963 3.75517 4.6677L3.70901 4.62705L0.120532 0.966603C-0.0401774 0.80267 -0.0401774 0.536882 0.120532 0.37295Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdownwhite);
export default __webpack_public_path__ + "static/media/Arrowdown white.276c74b89364901bde5326f04df725a2.svg";
export { ForwardRef as ReactComponent };